
<template>
	<el-popover
		placement="bottom"
		:title="column.field_name"
		:width="isContent(column.field)?500:400"
		ref="popoverRef"
		:disabled="isIndex || !hasFilter"
		@show="showPopover"
		@hide="showForm=false"
		
		trigger="click">
		<div v-if="showForm" class="popover-body">
			<template v-if="isContent(column.field)">
				<ContentType
					:dimension="isContent(column.field)"
					:list.sync="list"
					:load-data="(params)=>handleLoadData(params)"
					:loading="loading"
					:option="false"
					:defaultData="defaultData"
					:allData.sync="allData"
					ref="ContentTypeRef"
				/>
			</template>
			<template v-else>
				<div class="font12px">
					<p class="mb6">设置数据范围</p>
					<ESelect 
						v-model="formData.filterType"  
						clearable placeholder="请选择" 
						size="mini" class="mr10"
						style="width: 100px;"
					 >
                        <el-option 
							v-for="item in filterList"
							:key="item.value"
							:label="item.label" 
							:value="item.value"
						/>
                    </ESelect>
					<el-input-number 
						class="input-number"
						v-for="num in inputNum"
						:key="num"
						v-model="formData[num]" 
						:precision="2" size="mini" 
						placeholder="请输入"
						:controls="false"
						style="width: 100px;"
					 />
				</div>
			</template>
			<div class="tac mt10">
				<el-button type="primary" size="mini" @click="handleOnSubmit">确定</el-button>
			</div>
		</div>
		<span slot="reference" @click.stop :class="{'filter-field':isFilterField}" FilterField>{{column.field_name}}<i v-if="!isIndex && hasFilter" class="el-icon-arrow-down"/></span>
	</el-popover>
  
</template>

<script>
let POPOVER_REF = null;
import ContentType from '../../modal/conditionEditModal/contentType.vue'
import { getMaterialSecondConditionListApi } from '@/api'
import { 
	FILTER_NUMBER_DATA_OPTIONS, FILTER_NUMBER_DATA, DIMENSION_DATE_FORM,
	DIMENSION_NO_FILTER_LIST
} from '../../constant'
// doClose
export default {
    props: [ 'column', 'isIndex' ],
	inject: [ 'getDimensionData', 'global', 'secondCondition' ],
	components: { ContentType },
	data() {
		return {
			showForm: false,
			formData: { 
				filterType: ''
			},
			filterList: FILTER_NUMBER_DATA_OPTIONS,
			list: [],
			loading: false,
			allData: false,
			defaultData: {
				list: []
			}
		}
	},
	computed: {
		inputNum() {
			return FILTER_NUMBER_DATA[this.formData.filterType]?.input || 0
		},
		hasFilter() {
			// 过滤掉日期格式的  日期支持刷选
			const list = DIMENSION_NO_FILTER_LIST.filter(name=> !DIMENSION_DATE_FORM.includes(name))
			if (list.includes(this.column.field)) {
				return false
			}
			return true
		},
		secondConditionNames() {
			const cacheParamsData = this.global.cacheParamsData;
			const paramsData = JSON.parse(cacheParamsData);
			return (paramsData.where || []).map(v=>v.field)
		},
		isFilterField() {
			return this.secondConditionNames.includes(this.column.field)
		}
		
	},
	methods: {
		isContent(field) {
			const dimensionData = this.getDimensionData();
			return dimensionData[field];
		},
		async handleLoadData(defaultParams) {
			try {
				this.loading = true;
				const isPage = this.isContent(this.column.field).config.page
				const cacheParamsData = JSON.parse(this.global.cacheParamsData);
				const where = ( cacheParamsData.where || [] ).filter(item=> {
					return item.field !== this.column.field
				});
				const params = {
					...(Object.assign(cacheParamsData, {where})),
					...defaultParams,
					return_condition: this.column.field,
				};
				if (isPage) {
					const lastData = this.list[this.list.length - 1];
					params.last = lastData ? lastData.id: null
				};
				const { data } = await getMaterialSecondConditionListApi(params);
				if (params.search) {
					this.list = data.list;
				}else {
					this.list = this.list.concat(data.list);
				}
				if (data.list.length<20) {
					this.allData = true
				}
			} catch (error) {
				this.$message.error(error.info || error.message)
			}finally {
				this.loading = false;
			}
		},
		showPopover() {
			this.showForm = true;
			const ref = this.$refs.popoverRef
			if (POPOVER_REF && ref !== POPOVER_REF) {
				POPOVER_REF.doClose();
			}
			POPOVER_REF = ref;
			this.list = [];
			this.allData = false
			// 弹框显示
			console.log('弹框显示');
		},
		async handleOnSubmit() {
			if (this.isContent(this.column.field)) {
				const { list } = await this.$refs['ContentTypeRef'].getFormData();
				const data = {
					type: 'group',
					field: this.column.field,
					val: list.map(v=>v.id)
				}
				if (!list.length) {
					this.secondCondition(data, true);
				}else {
					this.secondCondition(data);
				};
				this.defaultData.list = list
			}else {
				const { filterType } = this.formData;
				const calc = FILTER_NUMBER_DATA[filterType]?.value
				const data = {
					field: this.column.field,
					type: 'data',
					calc
				}
				if (calc) {
					for (let index = 1; index <= this.inputNum; index++) {
						const num = this.formData[index];
						const i = index -1;
						data[`val${i?i: ''}`] = num;
					};
					const keys = Object.keys(data);
					if (keys.some(key=>key.indexOf('val')> -1)) {
						const hasValue = keys.filter(key=>key.indexOf('val')> -1).some(key=> typeof data[key] === 'number');
						if (hasValue) {
							this.secondCondition(data)
						}else {
							// 无值时删除二次筛选
							this.secondCondition(data, true)
						}
					}else {
						this.secondCondition(data)
					}
				}else {
					this.secondCondition(data, true)
				};
			};
			POPOVER_REF.doClose();
		}
	}
}
</script>

<style lang="scss" scoped>
.input-number {
	margin-right: 30px;
	position: relative;
	&:nth-child(2n) {
		&::before {
			content: "-";
			position: absolute;
			top: 0;
			left: -18px;
		}
	}
	&:last-child {
		margin-right: 0;
	}
}
.filter-field {
	color: #409eff;
}
</style>